export default __webpack_public_path__ + "static/media/vrf5-banner.62849842.png";